import ResponsiveDialog, {
  ResponsiveDialogActions,
  ResponsiveDialogContent,
  type ResponsiveDialogProps,
} from 'components/responsive-dialog';
import { FormattedMessage } from 'react-intl';
import { useId, type ReactNode } from 'react';
import type { ButtonProps } from '@mui/material';
import LoadingBackdrop from 'components/loading-backdrop';
import { Button, DialogContentText, DialogTitle } from '@mui/material';

export type ConfirmDialogProps = Omit<ResponsiveDialogProps, 'children' | 'onClose' | 'open' | 'title'> & {
  open: boolean;
  title: ReactNode;
  description: ReactNode;
  onClose: () => void;
  onConfirm: () => void;
  loading?: boolean;
  cancelLabel?: ReactNode;
  confirmLabel?: ReactNode;
  confirmColor?: ButtonProps['color'];
  disabled?: boolean;
};

const ConfirmDialog = ({
  open,
  title,
  description,
  onClose,
  onConfirm,
  loading = false,
  cancelLabel,
  confirmLabel,
  confirmColor = 'primary',
  disabled = false,
  ...dialogProps
}: ConfirmDialogProps) => {
  const actionsDisabled = disabled || loading;
  const descriptionId = useId();

  return (
    <ResponsiveDialog open={open} onClose={onClose} aria-describedby={descriptionId} {...dialogProps}>
      <DialogTitle>{title}</DialogTitle>
      <ResponsiveDialogContent>
        <DialogContentText id={descriptionId}>{description}</DialogContentText>
      </ResponsiveDialogContent>
      <ResponsiveDialogActions>
        <Button onClick={onClose} disabled={actionsDisabled}>
          {cancelLabel ?? <FormattedMessage id="forgotPassword.cancel" defaultMessage="Vazgeç" />}
        </Button>
        <Button variant="contained" type="button" onClick={onConfirm} disabled={actionsDisabled} color={confirmColor}>
          {confirmLabel ?? <FormattedMessage id="forgotPassword.continue" defaultMessage="Devam" />}
        </Button>
      </ResponsiveDialogActions>
      <LoadingBackdrop open={loading} />
    </ResponsiveDialog>
  );
};

export default ConfirmDialog;
